// Angular imports
import { Component, Input, OnInit } from '@angular/core';

// Service imports
import { AuthService } from '../../_services/auth.service';
import { UserService } from '../../_services/data-services/user.service';
import { ScreenService } from '../../_services/shared-services/screen.service';

// Model imports
import { UserInfoResultDto } from '../../_models/user-info-result-dto';

@Component({
    selector: 'app-user-panel',
    templateUrl: 'user-panel.component.html',
    styleUrls: ['./user-panel.component.scss']
})
export class UserPanelComponent implements OnInit {
    @Input() menuItems: any;
    @Input() menuMode: string;

    userInfo: UserInfoResultDto;
    isSmallScreen: boolean;
    screenSize: string;
    menuButtonWidth: string;

    constructor(
        private readonly authService: AuthService,
        private readonly userService: UserService,
        private readonly screenService: ScreenService
    ) {
        this.userInfo = this.userService.getCurrentUserInfo();
        this.updateScreenSize();
    }

    ngOnInit(): void {
        this.screenService.changed.subscribe(() => this.updateScreenSize());

        // when refreshing
        this.userInfo = this.userService.getCurrentUserInfo();
        this.authService.getSubjectLoginSuccess().subscribe((flag: boolean) => {
            if (flag === true) {
                this.userInfo = this.userService.getCurrentUserInfo(); // after login
            }
        });

        this.authService.getSubjectProfileImageUpdated().subscribe((data: any) => {
            // after the user saved a new profile
            this.userInfo.profileImage = data;
        });
    }

    private updateScreenSize(): void {
        this.screenSize = this.screenService.getCurrentScreenSize;
        this.isSmallScreen = this.screenService.isSmallScreen();
        const screenParams = this.screenService.getScreenParams(this.screenSize).userpanel;
        this.menuButtonWidth = screenParams.menuButtonWidth;
    }
}
